import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const clients = [{
  id: 1,
  name: "Einkaufszentrum Mitte",
  location: "BERLIN_ALEX",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_mall_01.png"
}, {
  id: 2,
  name: "Hauptbahnhof Nord",
  location: "HAMBURG_HBF",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_transport_01.png"
}, {
  id: 3,
  name: "Messegelände Süd",
  location: "MUENCHEN_MESSE",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_expo_01.png"
}, {
  id: 4,
  name: "Flughafen Terminal 1",
  location: "FRANKFURT_AIR",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_airport_01.png"
}, {
  id: 5,
  name: "City Galerie",
  location: "KOELN_CENTER",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_retail_01.png"
}, {
  id: 6,
  name: "Technologiepark West",
  location: "STUTTGART_TECH",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_tech_01.png"
}, {
  id: 7,
  name: "U-Bahn Netz",
  location: "BERLIN_BVG",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_metro_01.png"
}, {
  id: 8,
  name: "Shopping Arkaden",
  location: "DUESSELDORF_K",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_mall_02.png"
}, {
  id: 9,
  name: "Kulturpalast",
  location: "DRESDEN_KULTUR",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_culture_01.png"
}, {
  id: 10,
  name: "Business Tower",
  location: "FRANKFURT_SKY",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_office_01.png"
}, {
  id: 11,
  name: "Zentraler Omnibusbahnhof",
  location: "MUENCHEN_ZOB",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_transport_02.png"
}, {
  id: 12,
  name: "Opernpassage",
  location: "WIEN_OPERA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_public_01.png"
}, {
  id: 13,
  name: "Kaufhaus des Westens",
  location: "BERLIN_KDW",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_retail_02.png"
}, {
  id: 14,
  name: "Messe City",
  location: "LEIPZIG_FAIR",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_expo_02.png"
}, {
  id: 15,
  name: "Hafen City Center",
  location: "HAMBURG_PORT",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570539/img/client_logo_office_02.png"
}];
export default function Kundenvertrauen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}